import React from "react";
import "./Test.scss";
import { pages } from "./data";
/* utils */
import * as hooks from "./hooks";

import { SwitchTransition, CSSTransition } from "react-transition-group";
import classNames from "classnames";

const Test = () => {
  const test = hooks.useTest(pages);

  return (
    <section className="test" id="test">
      <div className="container">
        <div className="test-wrapper">
          <h2
            className={classNames("section-title", "test__title ", {
              title_hidden: test.page !== 0,
            })}
          >
            Пройдите тест!
          </h2>

          <SwitchTransition>
            <CSSTransition
              key={test.page}
              addEndListener={(node, done) => {
                node.addEventListener("transitionend", done, false);
              }}
              classNames="fade"
            >
              {test.renderCard()}
            </CSSTransition>
          </SwitchTransition>
        </div>
      </div>
    </section>
  );
};

export default Test;
